import './SearchPage.less';

export const prefix = 'bm-p-search';

export const navPrefix = 'bm-p-search-nav'

export { default } from './SearchPage';
